import { FileMimeTypes } from './consts';

// fixes some newline hydration
export function handleNewline(string: string): string {
  return string.replaceAll('\r\n', '\n');
}

const cleanText = (text: string) => text.replace('  ', ' ').trim();

export function getSalaryString(
  from: string | number | null | undefined,
  to: string | number | null | undefined,
  currency?: string,
  tax?: string | null,
): string | undefined {
  const { t } = useNuxtApp().$i18n;
  const fromLabel = t('FROM');
  const toLabel = t('TO');
  const currencyLabel = currency ?? '';
  const taxLabel = (
    typeof tax === 'string' && tax.length > 0
      ? tax === 'net'
        ? t('SALARY_TAX_NET')
        : tax === 'gross'
          ? t('SALARY_TAX_GROSS')
          : tax
      : ''
  ).toLowerCase();
  const fromAmount = from;
  const toAmount = to;
  if (fromAmount && toAmount) {
    return fromAmount === toAmount
      ? cleanText(`${fromAmount} ${currencyLabel} ${taxLabel}`)
      : cleanText(
          `${fromLabel} ${fromAmount} ${currencyLabel} ${toLabel.toLowerCase()} ${toAmount} ${currencyLabel} ${taxLabel}`,
        );
  } else if (fromAmount) {
    return cleanText(`${fromLabel} ${fromAmount} ${currencyLabel} ${taxLabel}`);
  } else if (toAmount) {
    return cleanText(`${toLabel} ${toAmount} ${currencyLabel} ${taxLabel}`);
  }
}

export const getExtensionsFromMimeTypeArray = (mimeTypes: string[]): string => {
  return mimeTypes
    .map((mimeType) => `.${FileMimeTypes[mimeType as keyof typeof FileMimeTypes]}`)
    .join(', ');
};
